import { Component, ViewEncapsulation, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { CreditDebitNotesModalService } from 'src/app/services/credit-debit-notes-modal/credit-debit-notes-modal.service';
import { CreditDebitNotesService } from 'src/app/services/credit-debit-notes/credit-debit-notes.service';
import { PaginatedResponse, PaginationInfo } from 'src/app/shared/models';
import { Observable, BehaviorSubject } from 'rxjs';

declare var bootstrap: any;
declare var KTMenu: any;

@Component({
  selector: 'app-manage-crdr-notes-list',
  templateUrl: './manage-crdr-notes-list.component.html',
  styleUrls: ['./manage-crdr-notes-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ManageCrdrNotesListComponent extends DestructorComponent implements OnInit, AfterViewInit {

  // Use BehaviorSubjects for reactive data management
  private creditDebitNotesSubject = new BehaviorSubject<any[]>([]);
  private paginationInfoSubject = new BehaviorSubject<PaginationInfo>({
    currentPage: 1,
    perPage: 20,
    total: 0,
    lastPage: 1,
    firstPage: 1
  });

  // Expose as observables for template
  creditDebitNotes$ = this.creditDebitNotesSubject.asObservable();
  paginationInfo$ = this.paginationInfoSubject.asObservable();

  // Getters for template access (if needed for synchronous access)
  get creditDebitNotes(): any[] {
    return this.creditDebitNotesSubject.value;
  }

  isLoading: boolean = false;

  get paginationInfo(): PaginationInfo {
    return this.paginationInfoSubject.value;
  }

  constructor(
    private _creditDebitNotesModalService: CreditDebitNotesModalService,
    private _creditDebitNotesService: CreditDebitNotesService
  ) {
    super();
  }

  ngOnInit(): void {
    this.GetData();
    this.setupModalSubscriptions();
  }

  ngAfterViewInit(): void {
    // Initialize KTMenu instances for dropdown menus
    this.initializeMenus();
  }

  private setupModalSubscriptions(): void {
    // Subscribe to modal service changes if needed
    this.subscriptions.push(
      this._creditDebitNotesModalService.selectedCreditDebitNote$.subscribe(creditDebitNote => {
        // This subscription helps track modal state changes
        console.log('Modal credit/debit note changed:', creditDebitNote);
      })
    );
  }

  GetData(): void {
    this.isLoading = true;
    this.subscriptions.push(
      this._creditDebitNotesService.GetData("1").subscribe({
        next: (response: PaginatedResponse<any>) => {
          console.log('API Response:', response);
          if (response.status && response.data) {
            this.creditDebitNotesSubject.next(response.data.data || []);
            this.paginationInfoSubject.next(response.data.pagination);
            console.log('Credit/Debit Notes set:', response.data.data);
            console.log('Pagination info:', response.data.pagination);
          } else {
            this.creditDebitNotesSubject.next([]);
            this.resetPagination();
            console.log('No data found in response');
          }
          this.isLoading = false;
          
          // Initialize menus after data loads
          this.refreshMenus();
        },
        error: (error) => {
          console.error('Error loading credit/debit notes:', error);
          this.creditDebitNotesSubject.next([]);
          this.resetPagination();
          this.isLoading = false;
        }
      })
    );
  }

  private resetPagination(): void {
    this.paginationInfoSubject.next({
      currentPage: 1,
      perPage: 20,
      total: 0,
      lastPage: 1,
      firstPage: 1
    });
  }

  // Modal methods
  openAddModal(): void {
    // Clear any selected credit/debit note to ensure add mode
    this._creditDebitNotesModalService.clearSelectedCreditDebitNote();

    // Open the modal
    const modalElement = document.getElementById('kt_modal_add_update_credit_debit_notes');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  openEditModal(creditDebitNote: any): void {
    // Set the selected credit/debit note for edit mode
    this._creditDebitNotesModalService.setSelectedCreditDebitNote(creditDebitNote);

    // Open the modal
    const modalElement = document.getElementById('kt_modal_add_update_credit_debit_notes');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  // Event handlers for modal events
  onCreditDebitNoteAdded(): void {
    console.log('Credit/Debit Note added, refreshing list...');
    this.GetData();
  }

  onCreditDebitNoteUpdated(): void {
    console.log('Credit/Debit Note updated, refreshing list...');
    this.GetData();
  }

  // Track by function for ngFor performance
  trackByFn(index: number, item: any): any {
    return item._id || index;
  }

  // Delete method (placeholder - implement as needed)
  deleteCreditDebitNote(note: any): void {
    console.log('Delete credit/debit note:', note);
    // Implement delete functionality here
  }

  // Initialize KTMenu instances
  private initializeMenus(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
        console.log('KTMenu instances initialized for credit/debit notes list');
      } else {
        console.warn('KTMenu is not available');
      }
    }, 100);
  }

  // Add this method to refresh menus after data loads
  private refreshMenus(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }
    }, 100);
  }
}
